import React from "react";
import DPHeadCellWithTooltip from "Components/DP/DPHeadCell/DPHeadCell";
import { Box, Typography } from "@material-ui/core";
import useStyles from "./styles";

const DisbursementStatusHeadCell = () => {
  const classes = useStyles();
  return <DPHeadCellWithTooltip
    label="Status"
    width={500}
    content={
      <Box>
        <Box className={classes.status}>
          <Typography variant="h6" className={classes.text}>
            Processing
          </Typography>
          <Typography variant="body1" className={classes.text}>
            File was uploaded by Admin and is waiting to be processed by DailyPay.
          </Typography>
        </Box>

        <Box className={classes.status}>
          <Typography variant="h6" className={classes.text}>
            Pending Approval
          </Typography>
          <Typography variant="body1" className={classes.text}>
            File is submitted and waiting for Secondary Approval.
          </Typography>
        </Box>

        <Box className={classes.status}>
          <Typography variant="h6" className={classes.text}>
            Rejected
          </Typography>
          <Typography variant="body1" className={classes.text}>
            File was rejected by Secondary Approver.
          </Typography>
        </Box>

        <Box className={classes.status}>
          <Typography variant="h6" className={classes.text}>
            Sent
          </Typography>
          <Typography variant="body1" className={classes.text}>
            File has been approved and submitted to DailyPay. All payments without validation errors will be processed by DailyPay.
          </Typography>
        </Box>

        <Box className={classes.status}>
          <Typography variant="h6" className={classes.text}>
            Failed
          </Typography>
          <Typography variant="body1" className={classes.text}>
            File was approved, but has not been processed by DailyPay. No payments in the file will be processed.
          </Typography>
        </Box>

      </Box>
    }
  />;
};

export default DisbursementStatusHeadCell;
